module.exports = __webpack_public_path__ + "img/refer_share_square_line.9d02641e.svg";